module.exports = __webpack_public_path__ + "static/media/calenderInactive.6360988b.png";